import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Row,
  Col,
  Button,
  Space,
  message,
  Layout,
  Modal,
  Input,
} from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import {
  createPublicInstitution,
  getPublicInstitutions,
  updatePublicInstitution,
} from "../api/public_institutions/publicInstitutionRequest";
import PermissionRender from "../components/PermissionRender";

const { Content } = Layout;

function PublicInstitutions() {
  const [publicInstitutions, setPublicInstitutions] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentInstitution, setCurrentInstitution] = useState({
    id: null,
    name: "",
  });
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchPublicInstitutions();
  }, []);

  // Fetch public institutions from API
  const fetchPublicInstitutions = async () => {
    setLoading(true);
    try {
      const data = await getPublicInstitutions();
      setPublicInstitutions(data); // Update state with the fetched data
    } catch (error) {
      message.error("Échec de la récupération des organismes publics");
    } finally {
      setLoading(false);
    }
  };

  // Handle adding or editing a public institution
  const handleAddInstitution = async () => {
    if (currentInstitution.name.trim()) {
      setIsSubmitting(true);
      try {
        if (isEditMode) {
          await updatePublicInstitution(currentInstitution); // Update public institution via API
          message.success("Organisme public modifié avec succès");
        } else {
          await createPublicInstitution(currentInstitution); // Create new public institution via API
          message.success("Organisme public ajouté avec succès");
        }
        resetForm();
        fetchPublicInstitutions(); // Refresh the public institution list
      } catch (error) {
        message.error("Erreur lors de l'enregistrement de l'organisme public");
      } finally {
        setIsSubmitting(false);
      }
    } else {
      message.error("Veuillez entrer un nom valide");
    }
  };

  const handleEditInstitution = (institution) => {
    setCurrentInstitution({ ...institution });
    setIsEditMode(true);
    setIsModalVisible(true);
  };

  const resetForm = () => {
    setCurrentInstitution({
      id: null,
      name: "",
    });
    setIsEditMode(false);
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "Nom",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      render: (text, record) => (
        <Space size="middle">
          <PermissionRender requiredPermission={["public_institutions", "update"]}>
            <Button
              icon={<EditOutlined />}
              onClick={() => handleEditInstitution(record)}
            >
              Modifier
            </Button>
          </PermissionRender>
        </Space>
      ),
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Content className="py-6 sm:px-6 lg:px-8">
        <Card className="mb-6 shadow-sm">
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24}>
          <PermissionRender requiredPermission={["public_institutions", "create"]}>

              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  resetForm();
                  setIsModalVisible(true);
                }}
                className="w-full"
              >
                Créer un nouvel organisme public
              </Button>
            </PermissionRender>
            </Col>
          </Row>
        </Card>

        <Card className="shadow-sm">
          <Table
            dataSource={publicInstitutions.map((institution) => ({
              key: institution.id,
              ...institution,
            }))}
            columns={columns}
            pagination={false}
            loading={loading}
          />
        </Card>

        <Modal
          title={
            isEditMode
              ? "Modifier l'Organisme Public"
              : "Ajouter un Organisme Public"
          }
          visible={isModalVisible}
          onOk={handleAddInstitution}
          onCancel={resetForm}
          confirmLoading={isSubmitting}
        >
          <Input
            placeholder="Nom *"
            value={currentInstitution.name}
            onChange={(e) =>
              setCurrentInstitution({
                ...currentInstitution,
                name: e.target.value,
              })
            }
            style={{ marginTop: "10px" }}
          />
        </Modal>
      </Content>
    </Layout>
  );
}

export default PublicInstitutions;
